"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.MaturitiesToJSON = exports.MaturitiesFromJSONTyped = exports.MaturitiesFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function MaturitiesFromJSON(json) {
    return MaturitiesFromJSONTyped(json, false);
}
exports.MaturitiesFromJSON = MaturitiesFromJSON;
function MaturitiesFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'nextMaturityDate': !(0, runtime_1.exists)(json, 'nextMaturityDate') ? undefined : json['nextMaturityDate'],
        'overdueMaturities': !(0, runtime_1.exists)(json, 'overdueMaturities') ? undefined : (0, _1.AmountFromJSON)(json['overdueMaturities']),
        'currentMaturities': !(0, runtime_1.exists)(json, 'currentMaturities') ? undefined : (0, _1.AmountFromJSON)(json['currentMaturities']),
        'grandTotal': !(0, runtime_1.exists)(json, 'grandTotal') ? undefined : (0, _1.AmountFromJSON)(json['grandTotal']),
        'currentAccountBalance': !(0, runtime_1.exists)(json, 'currentAccountBalance') ? undefined : (0, _1.AmountFromJSON)(json['currentAccountBalance']),
        'overdueMinimumRate': !(0, runtime_1.exists)(json, 'overdueMinimumRate') ? undefined : (0, _1.AmountFromJSON)(json['overdueMinimumRate']),
        'rsvFee': !(0, runtime_1.exists)(json, 'rsvFee') ? undefined : (0, _1.AmountFromJSON)(json['rsvFee']),
        'overdueMinimumRateWithRsvFee': !(0, runtime_1.exists)(json, 'overdueMinimumRateWithRsvFee') ? undefined : (0, _1.AmountFromJSON)(json['overdueMinimumRateWithRsvFee']),
        'nextMaturities': !(0, runtime_1.exists)(json, 'nextMaturities') ? undefined : (json['nextMaturities'].map(_1.MaturitiesNextMaturitiesFromJSON)),
        'showNextPaymentDateLink': !(0, runtime_1.exists)(json, 'showNextPaymentDateLink') ? undefined : json['showNextPaymentDateLink'],
    };
}
exports.MaturitiesFromJSONTyped = MaturitiesFromJSONTyped;
function MaturitiesToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'nextMaturityDate': value.nextMaturityDate,
        'overdueMaturities': (0, _1.AmountToJSON)(value.overdueMaturities),
        'currentMaturities': (0, _1.AmountToJSON)(value.currentMaturities),
        'grandTotal': (0, _1.AmountToJSON)(value.grandTotal),
        'currentAccountBalance': (0, _1.AmountToJSON)(value.currentAccountBalance),
        'overdueMinimumRate': (0, _1.AmountToJSON)(value.overdueMinimumRate),
        'rsvFee': (0, _1.AmountToJSON)(value.rsvFee),
        'overdueMinimumRateWithRsvFee': (0, _1.AmountToJSON)(value.overdueMinimumRateWithRsvFee),
        'nextMaturities': value.nextMaturities === undefined ? undefined : (value.nextMaturities.map(_1.MaturitiesNextMaturitiesToJSON)),
        'showNextPaymentDateLink': value.showNextPaymentDateLink,
    };
}
exports.MaturitiesToJSON = MaturitiesToJSON;
//# sourceMappingURL=Maturities.js.map